"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocationFilter = LocationFilter;
const jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable no-restricted-syntax */
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const elements_1 = require("@src/components/elements");
const types_1 = require("@src/types");
const LocationSelect_1 = require("@src/components/modules/forms/offer-notification-subscription-form/LocationSelect");
const styled_components_1 = __importDefault(require("styled-components"));
const offer_filter_context_1 = require("@src/components/pages/offers/offer-filter-context");
const LocationFilter_model_1 = require("./LocationFilter.model");
function LocationFilter({ locationFilterItems, isLoading, setShowLocationPlaceholder }) {
    const intl = (0, react_intl_1.useIntl)();
    const { locationFiltersSelected, setLocationFiltersSelected } = (0, offer_filter_context_1.useOffersFilterContextValue)();
    const isAtLeastOneLocationSelected = locationFiltersSelected.length > 0;
    const isAbroadSelected = locationFiltersSelected.includes(types_1.ABROAD);
    const isRemoteSelected = locationFiltersSelected.includes(types_1.REMOTE);
    const locationTreeData = react_1.default.useMemo(() => [
        {
            title: (0, LocationFilter_model_1.getLocationTitleWithCount)(intl.formatMessage({ id: 'location.abroad' }), (locationFilterItems === null || locationFilterItems === void 0 ? void 0 : locationFilterItems.abroadOfferCount) || 0, isAtLeastOneLocationSelected, isAbroadSelected),
            count: locationFilterItems.abroadOfferCount,
            value: types_1.ABROAD,
            disabled: locationFilterItems.abroadOfferCount === 0 && !locationFiltersSelected.includes(types_1.ABROAD),
        },
        {
            title: (0, LocationFilter_model_1.getLocationTitleWithCount)(intl.formatMessage({ id: 'location.remote' }), (locationFilterItems === null || locationFilterItems === void 0 ? void 0 : locationFilterItems.remoteOfferCount) || 0, isAtLeastOneLocationSelected, isRemoteSelected),
            count: locationFilterItems.remoteOfferCount,
            value: types_1.REMOTE,
            disabled: locationFilterItems.remoteOfferCount === 0 && !locationFiltersSelected.includes(types_1.REMOTE),
        },
        ...(0, LocationFilter_model_1.buildLocationTree)(locationFilterItems.locations || [], locationFiltersSelected, intl, isAtLeastOneLocationSelected, locationFilterItems.locations || []),
    ], [
        locationFilterItems,
        isAtLeastOneLocationSelected,
        locationFiltersSelected,
        isAbroadSelected,
        isRemoteSelected,
        intl,
    ]);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(IconStyled, { type: "pin-location" }), (0, jsx_runtime_1.jsx)(LocationSelect_1.LocationSelect, { value: locationFiltersSelected, onChange: setLocationFiltersSelected, locationTree: locationTreeData, isLoading: isLoading, setShowLocationPlaceholder: setShowLocationPlaceholder })] }));
}
const IconStyled = (0, styled_components_1.default)(elements_1.Icon) `
	position: absolute;
	z-index: 2;
	top: 30%;
	left: 8px;

	svg {
		width: 16px;
		margin-right: 4px;
	}
`;
